import React from 'react'
import { Page } from '../../components/page'
import RecoverFinish from '../../blocks/recover-finish'

export default () => (
  <Page name="RECOVER_FINISH" title="Complete your password reset">
    <RecoverFinish />
  </Page>
)
